import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export type AppIconSlot = {
  id: string;
  slot_key: string;
  label: string;
  required_width: number;
  required_height: number;
  storage_path: string | null;
  original_filename: string | null;
  public_url: string | null;
  updated_at: string;
};

export function useAppIconSlots() {
  return useQuery({
    queryKey: ["app-icon-slots"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("app_icon_slots")
        .select("*")
        .order("required_width", { ascending: false });
      if (error) throw error;
      return data as AppIconSlot[];
    },
    staleTime: 5 * 60 * 1000,
  });
}

/** Get a specific slot's public_url by key */
export function getSlotUrl(slots: AppIconSlot[] | undefined, key: string): string | null {
  return slots?.find((s) => s.slot_key === key)?.public_url ?? null;
}
